import { areaCheck, submitFetch, token } from '@/js/components/common'
import FormValidatorLite from '@/js/components/formValidatorLite'
import FileUpload from '@/js/components/fileUpload'
import Tag from "@/js/components/tag"
import alertifyjs from 'alertifyjs'
class FileUploadImage extends FileUpload {
    loadedFile(element, reader) {
        $(element).find('figure').remove();
        let imgObj = $('<img />').attr('src', reader.result)
        imgObj = $('<figure />').addClass('photo uploading').show().append(imgObj);
        $(element).find('.preview').prepend(imgObj);
    }

    uploadedFile(element, resp) {
        if (resp.file.type == "url") {
            // urlからのアップロードプレビュー用
            if ($(element).find('figure').length) {
                $(element).find('figure img').attr('src', resp.file.url)
            } else {
                let imgObj = $('<img />').attr('src', resp.file.url)
                imgObj = $('<figure />').addClass('photo').show().append(imgObj);
                $(element).find('.preview').prepend(imgObj);
            }
        } else {
            $(element).find('figure').removeClass('uploading')
        }
        $(element).find(`input[name="${this.settings.fileNameKey}"]`).val(resp.file.url).trigger('change')
    }

    deletedFile(element, resp) {
        $(element).find('figure').remove();
        $(element).find(`input[name="${this.settings.fileNameKey}"]`).val('').trigger('change')
    }
    setCloneObj(obj) {
        obj.find('figure').remove()
    }
    error(element) {
        $(element).find('figure').remove()
        alert('アップロードエラー')
    }
}

const main = () => {
    if(!document.querySelector('#page-voice-create')) return;

    const fileUpload = new FileUploadImage({
        fileNameKey: 'photo',
        typeFilter: ['image.*'],
        fileSizeLimit: 10,
        uploadPath: '/file/image/upload',
        uploadDir: 'voice',
        ajaxSetup: {
            headers: {
                'X-CSRF-TOKEN': token
            }
        },
    })

    const formValidator = new FormValidatorLite({
        renderAreaSelector: '#input',
        renderErrorCnt: false,
        formObjSelector: '#create-form',
        submitAction: async (obj, values) => {
            if (!window.confirm('投稿します。よろしいですか？')) {
                return false
            }
            $(obj).prop('disabled', true)
            let path = formValidator.config.formObj.getAttribute('action')
            let resp = await formValidator.submitAjax(values, path, {
                headers: {
                    'X-CSRF-TOKEN': token
                },
            })
            $(obj).prop('disabled', false)
            if (resp.success) {
                let dirPath = resp.state == "voice" ? "" : resp.state
                let completePath
                switch (true) {
                    case /\/admin\//.test(path):
                        completePath = "/admin/voice"
                        break
                    case /\/user\//.test(path):
                        completePath = "/user/voice/complete"
                        break
                    default:
                        completePath = "/voice/complete"
                }
                window.location.replace(completePath)
            } else {
                alertifyjs.set('notifier', 'position', 'top-center')
                alertifyjs.error('登録エラー：登録処理に失敗しました')
            }
        },
    })

    const tag = new Tag({
        addValues: {
            modelName: 'voices'
        },
        fetchSetup: {
            headers: {
                'X-CSRF-TOKEN': token
            },
        }
    })


    areaCheck()

    $('#delete-form').submit(e => {
        if (!window.confirm('この投稿を削除します。よろしいですか？\n※削除した投稿は元に戻せません')) {
            return false
        }
        let path = $(e.currentTarget).attr('action')
        submitFetch(path, 'POST', {
            '_method': 'DELETE'
        }, {
            headers: {
                'X-CSRF-TOKEN': token
            }
        })
            .then(resp => {
                location.href = location.href.replace(/\d+\/edit$/, "")
            })
        return false
    })

}
export default main;
